import { ROLES } from 'utils/Constants';
import { getEmptyCheckFn } from 'utils/contentValidation';

const { useState, useCallback } = require('react');

export const useWriterFormValidation = ({
  actualTextContent,
  actualTextWordCount,
  formData,
  initialTextWordCount,
  keyword,
  metaDescriptionTag,
  minWords,
  orderType,
  textTitle,
  textType,
  titleTag,
  validTextNbr,
  semanticScore,
  orderContentType,
}) => {
  const [disabledForm, setDisabledForm] = useState(true);

  const checkValidForm = useCallback(() => {
    // CASE 1: SMART_WITH_REVIEW + GMB: no title tag, no meta description, no analyse result required
    if (
      (!formData || (formData && !formData.delivered)) &&
      textTitle.length > 0 &&
      keyword.length > 0 &&
      validTextNbr &&
      orderType === 'SMART_WITH_REVIEW' &&
      orderContentType === 'GMB'
    ) {
      setDisabledForm(false);
      return;
    }
    // CASE 2: NON_TRANSLATED text: requires textTitle , keyword ,titleTag, metaDescriptionTag, analyseResult (semanticEnrichment >= 85 for non-SMART_WITH_REVIEW)
    if (
      (!formData || (formData && !formData.delivered)) &&
      textTitle.length > 0 &&
      keyword.length > 0 &&
      titleTag.length > 0 &&
      metaDescriptionTag.length > 0 &&
      validTextNbr &&
      (orderType !== 'SMART_WITH_REVIEW' ? semanticScore >= 85 : true) &&
      textType === 'NON_TRANSLATED'
    ) {
      setDisabledForm(false);
      return;
    }

    const isEmpty = getEmptyCheckFn(ROLES.WRITER);

    // CASE 3: TRANSLATED text: requires word count check and non-empty content

    if (
      (!formData || (formData && !formData.delivered)) &&
      textTitle.length > 0 &&
      keyword.length > 0 &&
      titleTag.length > 0 &&
      metaDescriptionTag.length > 0 &&
      initialTextWordCount &&
      !isEmpty(actualTextContent) &&
      actualTextWordCount >= minWords &&
      textType === 'TRANSLATED'
    ) {
      setDisabledForm(false);
      return;
    }

    // CASE 4: COMBINED text: similar to NON_TRANSLATED but does not require validTextNbr

    if (
      (!formData || (formData && !formData.delivered)) &&
      textTitle.length > 0 &&
      keyword.length > 0 &&
      titleTag.length > 0 &&
      metaDescriptionTag.length > 0 &&
      // validTextNbr &&

      (orderType !== 'SMART_WITH_REVIEW' ? semanticScore >= 85 : true) &&
      actualTextWordCount >= minWords &&
      textType === 'COMBINED'
    ) {
      setDisabledForm(false);
      return;
    }

    // DEFAULT: form remains disabled if none of the above cases are satisfied

    setDisabledForm(true);
    return;
  }, [
    actualTextContent,
    actualTextWordCount,
    formData,
    initialTextWordCount,
    keyword.length,
    metaDescriptionTag.length,
    minWords,
    textTitle.length,
    textType,
    titleTag.length,
    validTextNbr,
  ]);

  return {
    checkValidForm,
    disabledForm,
  };
};
